import "core-js/modules/es.string.starts-with.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2feb3359"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "tab-absolute"
};
var _hoisted_2 = {
  "class": "tab-footer"
};
var _hoisted_3 = ["onClick"];
var _hoisted_4 = ["src"];
var _hoisted_5 = ["src"];
import Activity from '@/common/components/Activity.vue';
import AreaView from '@/common/components/AreaView.vue';
import TransitionRouteView from '@/common/components/TransitionRouteView.vue';
import { useRoute } from 'vue-router';
import { useNavigation } from '../util/navigation';
export default /*#__PURE__*/_defineComponent({
  props: {
    tabs: Array
  },
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toReplace = _useNavigation.toReplace;
    var route = useRoute();
    var toTab = function toTab(to) {
      toReplace("".concat(to));
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(Activity, {
        "class": "home-view"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(AreaView, {
            scroll: false
          }, {
            footer: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, function (item) {
                return _openBlock(), _createElementBlock("div", {
                  "class": _normalizeClass(["tab-footer-item", {
                    'selected': _unref(route).fullPath.startsWith(item.path)
                  }]),
                  key: item.id,
                  onClick: function onClick($event) {
                    return toTab(item.path);
                  }
                }, [_createElementVNode("img", {
                  "class": "normal",
                  src: item.icon
                }, null, 8, _hoisted_4), _createElementVNode("img", {
                  "class": "selected",
                  src: item.selectedIcon
                }, null, 8, _hoisted_5), _createElementVNode("p", null, _toDisplayString(item.title), 1)], 10, _hoisted_3);
              }), 128))])];
            }),
            "default": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createVNode(TransitionRouteView)])];
            }),
            _: 1
          })];
        }),
        _: 1
      });
    };
  }
});